import React, { Fragment } from "react";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import TermsContentEn from "./TermsContentEn";
import { useTranslation } from "react-i18next";
import TermsContentAr from "./TermsContentAr";
import TermsContentFr from "./TermsContentFr";

function AuthTermsPage() {
    const { i18n } = useTranslation();
    const lang = i18n.language;

  return (
    <Fragment>
      <UserNavBar />
      {lang==='ar'? <TermsContentAr/>:
      lang === 'fr' ? <TermsContentFr /> : <TermsContentEn />}
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default AuthTermsPage;
